import * as React from 'react';

import type {SavedFilter, SavedReportType, SavedReportId} from 'nutshell-core/types';

import {
    SavedFilterModalRow,
    getSavedFilterSubtitle,
} from '../base/saved-filter-modal/saved-filter-modal-row';

import {
    getReportKeyFromReportSavedType,
    getReportTitle,
    getReportIcon,
    getReportBaseUrl,
} from './report-constants';

type Props = {
    report: SavedFilter<SavedReportType>;
    isSelected: boolean;
    onSelect: () => any;
    onDelete: (arg1: SavedReportId) => any;
    sessionUserId: string | null | undefined;
};

export class SavedReportsRow extends React.Component<Props> {
    render() {
        const {report} = this.props;

        const reportKey = getReportKeyFromReportSavedType(report.reportType);
        const reportTitle = `${getReportTitle(reportKey)} report`;
        const reportBaseUrl = getReportBaseUrl(reportKey);
        const ReportIcon = getReportIcon(reportKey);
        const pathname =
            reportKey === 'activity' || reportKey === 'tasks'
                ? reportBaseUrl
                : `${reportBaseUrl}/details`;

        return (
            <SavedFilterModalRow
                savedFilter={this.props.report}
                subtitle={getSavedFilterSubtitle(report, reportTitle, this.props.sessionUserId)}
                location={{pathname, search: `?report[id]=${report.id}&${report.value}`}}
                icon={ReportIcon}
                isSelected={this.props.isSelected}
                onSelect={this.props.onSelect}
                onDelete={this.props.onDelete}
                // @ts-expect-error
                sessionUserId={this.props.sessionUserId}
            />
        );
    }
}
